window._define('common/router', ['jquery', 'app/core'], function ($, core) { 'use strict';
    var ROUTES = $.extend({}, core.getPreferences().routes);

    function getUrl(routePath, routeData) {
        var reg = /:(\w+)/gi,
            match,
            val;

        do {
            match = reg.exec(routePath);
            if (match) {
                val = routeData[match[1]];
                routePath = routePath.replace(':' + match[1], val);
            }
        } while (match);

        return routePath;
    }

    return {
        ROUTES: ROUTES,
        getUrl: getUrl,
    };
});
